module.exports = __webpack_public_path__ + "img/Iraninan-Poshesh.f768ebf.webp";